import { IDaySettingPartial } from '../../../app/entities/DaySetting'

export function runRouteOptimizationForLocation(
  date: Date,
  locationId?: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/test/route-optimization`,
    body: {
      date: date.toISOString().split('T')[0],
      locationId,
    },
  }
}

export function testORTools(body: { locationId: string; date: number }) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/test-or-tools`,
    body,
  }
}

export function getOrderByWorkOrderId(workOrderId: number) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/order-by-work-order-id?workOrderId=${workOrderId}`,
  }
}

export function addCompletedInvoice(body: any) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/add-completed-invoice`,
    body,
  }
}

export function getDriveTimeDetails(
  locationObjectId: string,
  fromDate: string,
  toDate: string,
) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/drive-time-details?locationObjectId=${locationObjectId}&fromDate=${fromDate}&toDate=${toDate}`,
  }
}

export function updateRoutingAlgorithm(
  routingAlgorithm: string,
  locationObjectId: string,
) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/update-routing-algorithm`,
    body: { routingAlgorithm, locationObjectId },
  }
}

export function adjustDeliveryCandidateStatuses(
  locationObjectId: string,
  date: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/adjust-delivery-candidate-statuses`,
    body: { locationObjectId, date },
  }
}

export function getActiveTechniciansForLocation(locationId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/location/${locationId}/active-technicians`,
  }
}

export function testScheduleChangeImpact(
  technicianObjectId: string,
  proposedDaySetting: IDaySettingPartial,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/test-schedule-change-impact`,
    body: {
      technicianObjectId,
      proposedDaySetting,
    },
  }
}

export function triggerDaySettingsMaintenance() {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/trigger-day-settings-maintenance`,
  }
}

export function moveSchedulingDataToNewDay(
  locationObjectId: string,
  sourceDate: string,
  targetDate: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/move-scheduling-data-to-new-day`,
    body: { locationObjectId, sourceDate, targetDate },
  }
}
